/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_Leveling_RecountInputs */



/**
* | output |
* | --- |
* | "Recount past activity under new rules" |
*
* @param {Pricing_Compare_Leveling_RecountInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_leveling_recount = /** @type {((inputs?: Pricing_Compare_Leveling_RecountInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_Leveling_RecountInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пересчёт прошлой активности по новым правилам")
	return /** @type {LocalizedString} */ ("Recount past activity under new rules")
});